import { render, staticRenderFns } from "./MessageBoxView.vue?vue&type=template&id=c0bf4c60&scoped=true&"
import script from "./MessageBoxView.vue?vue&type=script&lang=js&"
export * from "./MessageBoxView.vue?vue&type=script&lang=js&"
import style0 from "./MessageBoxView.vue?vue&type=style&index=0&id=c0bf4c60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bf4c60",
  null
  
)

export default component.exports